import { AddAdminModalContainerLoadable } from 'modals/AddAdmin';
import { AddEditIntegrationModalContainerLoadable } from 'modals/AddEditIntegration';
import { AddEditWorkHistoryJobModalContainerLoadable } from 'modals/AddEditWorkHistoryJob';
import { AddOrEditImageModalContainerLoadable } from 'modals/AddOrEditImage';
import { AdminRequestModalContainerLoadable } from 'modals/AdminRequest';
import { ApproveItemModalContainerLoadable } from 'modals/ApproveItem';
import { AutoPublishIntegrationModalContainerLoadable } from 'modals/AutoPublishIntegration';
import { CancelCreditsModalContainerLoadable } from 'modals/CancelCredits';
import { ConfirmMergeOrgModalLoadable } from 'modals/ConfirmMergeOrg';
import { ConfirmationModalContainerLoadable } from 'modals/Confirmation';
import { ContactRecommendedCandidateModalLoadable } from 'modals/ContactRecommendedCandidate';
import { CreateSupportCaseModalContainerLoadable } from 'modals/CreateSupportCase';
import { DeferQueueItemModalContainerLoadable } from 'modals/DeferQueueItem';
import { DeleteAccountModalContainerLoadable } from 'modals/DeleteAccount';
import { DeleteCategoryModalContainerLoadable } from 'modals/DeleteCategory';
import { DeleteContentModalContainerLoadable } from 'modals/DeleteContent';
import { DeleteEmailPromoModalContainerLoadable } from 'modals/DeleteEmailPromo';
import { DeleteHeroSearchModalContainerLoadable } from 'modals/DeleteHeroSearch';
import { DeleteIntegrationModalContainerLoadable } from 'modals/DeleteIntegration';
import { DeleteJobFamilyModalContainerLoadable } from 'modals/DeleteJobFamily';
import { DeleteJobSynonymModalContainerLoadable } from 'modals/DeleteJobSynonym';
import { DeleteJobTitleModalLoadable } from 'modals/DeleteJobTitle';
import { DeleteLandingPageLocationModalContainerLoadable } from 'modals/DeleteLandingPageLocation';
import { DeleteListingModalContainerLoadable } from 'modals/DeleteListing';
import { DeleteLocationGroupModalContainerLoadable } from 'modals/DeleteLocationGroup';
import { DeleteOrgModalContainerLoadable } from 'modals/DeleteOrg';
import { DeleteScheduledContentModalContainerLoadable } from 'modals/DeleteScheduledContent';
import { DeleteSubsiteModalContainerLoadable } from 'modals/DeleteSubsite';
import { DeleteWorkHistoryJobModalContainerLoadable } from 'modals/DeleteWorkHistoryJob';
import { DuplicateContentModalContainerLoadable } from 'modals/DuplicateContent';
import { EmailAlertModalContainerLoadable } from 'modals/EmailAlert';
import { EmailSignupModalContainerLoadable } from 'modals/EmailSignup';
import { FinishOauthSignupModalContainerLoadable } from 'modals/FinishOauthSignup';
import { FlagListingModalContainerLoadable } from 'modals/FlagListing';
import { ForgotPasswordModalContainerLoadable } from 'modals/ForgotPassword';
import { FreezeListingModalContainerLoadable } from 'modals/FreezeListing';
import { GenericUncloseableModalLoadable } from 'modals/GenericUncloseable';
import { GradFairRegisterModalContainerLoadable } from 'modals/GradFairRegister';
import { GradProgramContactModalContainerLoadable } from 'modals/GradProgramContact';
import { GradProgramContactSeeMoreInfoModal } from 'modals/GradProgramContactSeeMoreInfo';
import { InformationRequiredModalContainerLoadable } from 'modals/InformationRequired';
import { LeadsNotificationPreferencesModalContainerLoadable } from 'modals/LeadsNotificationPreferences';
import { LoginModalContainerLoadable } from 'modals/Login';
import { MarkAsSpamModalContainerLoadable } from 'modals/MarkAsSpam';
import { MediaGalleryModalContainerLoadable } from 'modals/MediaGallery';
import { NotificationPreferencesModalContainerLoadable } from 'modals/NotificationPreferences';
import { OrgHideRepostedListingsModalContainerLoadable } from 'modals/OrgHideRepostedListings';
import { PreviewScheduledContentModalContainerLoadable } from 'modals/PreviewScheduledContent';
import { RefundPaymentModalContainerLoadable } from 'modals/RefundPayment';
import { RejectItemModalContainerLoadable } from 'modals/RejectItem';
import { RemovePaymentMethodModalContainerLoadable } from 'modals/RemovePaymentMethod';
import { SaveListingModalContainerLoadable } from 'modals/SaveListing';
import { SelectContentBlockModalContainerLoadable } from 'modals/SelectContentBlock';
import { ShareListingModalContainerLoadable } from 'modals/ShareListing';
import { ShareNewListingModalLoadable } from 'modals/ShareNewListing';
import { SignupModalContainerLoadable } from 'modals/Signup';
import { StaffAddEditIntegrationModalContainerLoadable } from 'modals/StaffAddEditIntegration';
import { StaffChangePasswordModalContainerLoadable } from 'modals/StaffChangePassword';
import { StaffDeleteIntegrationModalContainerLoadable } from 'modals/StaffDeleteIntegration';
import { StaffDeleteOrgModalContainerLoadable } from 'modals/StaffDeleteOrg';
import { StaffGradFairAddToWaitlistModalContainerLoadable } from 'modals/StaffGradFairAddToWaitlist';
import { StaffGradFairCancelRegistrationModalContainerLoadable } from 'modals/StaffGradFairCancelRegistration';
import { StaffGradFairInviteModalContainerLoadable } from 'modals/StaffGradFairInvite';
import { StaffGradFairRegisterModalContainerLoadable } from 'modals/StaffGradFairRegister';
import { StaffGradFairRegistrationSponsorOrHostModalContainerLoadable } from 'modals/StaffGradFairRegistrationSponsorOrHost';
import { StaffGradFairRemoveFromWaitlistModalContainerLoadable } from 'modals/StaffGradFairRemoveFromWaitlist';
import { StaffLoginAsModalContainerLoadable } from 'modals/StaffLoginAs';
import { VatNumberModalContainerLoadable } from 'modals/VatNumber';
import { VerifyEmailModalContainerLoadable } from 'modals/VerifyEmail';
import { VoidLineItemModalContainerLoadable } from 'modals/VoidLineItem';

import { ModalType } from './ModalType';

export const modalComponentByModalType: Record<ModalType, unknown> = {
  SHARE_NEW_LISTING: ShareNewListingModalLoadable,
  SHARE_LISTING: ShareListingModalContainerLoadable,
  SAVE_LISTING: SaveListingModalContainerLoadable,
  FLAG_LISTING: FlagListingModalContainerLoadable,
  EMAIL_ALERT: EmailAlertModalContainerLoadable,
  EMAIL_SIGNUP: EmailSignupModalContainerLoadable,
  VERIFY_EMAIL: VerifyEmailModalContainerLoadable,
  INFORMATION_REQUIRED: InformationRequiredModalContainerLoadable,
  ADMIN_REQUEST: AdminRequestModalContainerLoadable,
  LEADS_NOTIFICATION_PREFERENCES:
    LeadsNotificationPreferencesModalContainerLoadable,
  NOTIFICATION_PREFERENCES: NotificationPreferencesModalContainerLoadable,
  LOGIN: LoginModalContainerLoadable,
  SIGNUP: SignupModalContainerLoadable,
  FORGOT_PASSWORD: ForgotPasswordModalContainerLoadable,
  DELETE_ACCOUNT: DeleteAccountModalContainerLoadable,
  REMOVE_PAYMENT_METHOD: RemovePaymentMethodModalContainerLoadable,
  DELETE_LISTING: DeleteListingModalContainerLoadable,
  DELETE_ORG: DeleteOrgModalContainerLoadable,
  ADD_ADMIN: AddAdminModalContainerLoadable,
  CONFIRMATION: ConfirmationModalContainerLoadable,
  ADD_OR_EDIT_IMAGE: AddOrEditImageModalContainerLoadable,
  MEDIA_GALLERY: MediaGalleryModalContainerLoadable,
  VAT_NUMBER: VatNumberModalContainerLoadable,
  HIDE_REPOSTED_LISTINGS: OrgHideRepostedListingsModalContainerLoadable,
  GRAD_FAIR_REGISTER: GradFairRegisterModalContainerLoadable,
  SELECT_CONTENT_BLOCK: SelectContentBlockModalContainerLoadable,
  DELETE_CONTENT: DeleteContentModalContainerLoadable,
  DELETE_SCHEDULED_CONTENT: DeleteScheduledContentModalContainerLoadable,
  PREVIEW_SCHEDULED_CONTENT: PreviewScheduledContentModalContainerLoadable,
  DEFER_QUEUE_ITEM: DeferQueueItemModalContainerLoadable,
  REJECT_ITEM: RejectItemModalContainerLoadable,
  APPROVE_ITEM: ApproveItemModalContainerLoadable,
  MARK_AS_SPAM: MarkAsSpamModalContainerLoadable,
  FREEZE_LISTING: FreezeListingModalContainerLoadable,
  CREATE_SUPPORT_CASE: CreateSupportCaseModalContainerLoadable,
  CONTACT_RECOMMENDED_CANDIDATE: ContactRecommendedCandidateModalLoadable,
  STAFF_DELETE_ORG: StaffDeleteOrgModalContainerLoadable,
  STAFF_CHANGE_PASSWORD: StaffChangePasswordModalContainerLoadable,
  CONFIRM_MERGE_ORG: ConfirmMergeOrgModalLoadable,
  DELETE_CATEGORY: DeleteCategoryModalContainerLoadable,
  DELETE_SUBSITE: DeleteSubsiteModalContainerLoadable,
  GRAD_PROGRAM_CONTACT: GradProgramContactModalContainerLoadable,
  REFUND_PAYMENT_MODAL: RefundPaymentModalContainerLoadable,
  VOID_LINE_ITEM: VoidLineItemModalContainerLoadable,
  CANCEL_CREDITS: CancelCreditsModalContainerLoadable,
  STAFF_GRAD_FAIR_REGISTER: StaffGradFairRegisterModalContainerLoadable,
  STAFF_GRAD_FAIR_CANCEL_REGISTRATION:
    StaffGradFairCancelRegistrationModalContainerLoadable,
  STAFF_GRAD_FAIR_SPONSOR_OR_HOST:
    StaffGradFairRegistrationSponsorOrHostModalContainerLoadable,
  STAFF_GRAD_FAIR_ADD_TO_WAITLIST:
    StaffGradFairAddToWaitlistModalContainerLoadable,
  STAFF_GRAD_FAIR_INVITE: StaffGradFairInviteModalContainerLoadable,
  STAFF_DELETE_EMAIL_PROMO: DeleteEmailPromoModalContainerLoadable,
  GENERIC_UNCLOSEABLE: GenericUncloseableModalLoadable,
  DELETE_HERO_SEARCH: DeleteHeroSearchModalContainerLoadable,
  DELETE_JOB_FAMILY: DeleteJobFamilyModalContainerLoadable,
  DELETE_JOB_TITLE: DeleteJobTitleModalLoadable,
  DELETE_JOB_SYNONYM: DeleteJobSynonymModalContainerLoadable,
  GRAD_PROGRAM_CONTACT_SEE_MORE_INFO: GradProgramContactSeeMoreInfoModal,
  STAFF_GRAD_FAIR_REMOVE_FROM_WAITLIST:
    StaffGradFairRemoveFromWaitlistModalContainerLoadable,
  STAFF_LOGIN_AS_USER: StaffLoginAsModalContainerLoadable,
  FINISH_OAUTH_SIGNUP: FinishOauthSignupModalContainerLoadable,
  ADD_EDIT_WORK_HISTORY_JOB: AddEditWorkHistoryJobModalContainerLoadable,
  DELETE_WORK_HISTORY_JOB: DeleteWorkHistoryJobModalContainerLoadable,
  ADD_EDIT_INTEGRATION: AddEditIntegrationModalContainerLoadable,
  STAFF_ADD_EDIT_INTEGRATION: StaffAddEditIntegrationModalContainerLoadable,
  AUTO_PUBLISH_INTEGRATION: AutoPublishIntegrationModalContainerLoadable,
  DELETE_INTEGRATION: DeleteIntegrationModalContainerLoadable,
  STAFF_DELETE_INTEGRATION: StaffDeleteIntegrationModalContainerLoadable,
  DUPLICATE_CONTENT: DuplicateContentModalContainerLoadable,
  DELETE_LOCATION_GROUP: DeleteLocationGroupModalContainerLoadable,
  DELETE_LOCATION: DeleteLandingPageLocationModalContainerLoadable,
};
